const data = [
    { name: 'Aptitude', total: 10, correct: 7, wrong: 3, percentage: '70' },
    { name: 'Reasoning', total: 10, correct: 5, wrong: 5, percentage: '50' },
    { name: 'Verbal', total: 10, correct: 6, wrong: 4, percentage: '60' },
    { name: 'English', total: 10, correct: 8, wrong: 2, percentage: '80' },
 
  ];
  
  export default data;